export const accountPath = '/account';
export const authRedirectPath = '/auth-redirect/'; // As set in KeyCloak/"Valid redirect URIs"
export const logoutPath = '/logout';
export const signUpPath = '/sign-up';
export const verifyEmailPath = '/verify-email';
